
// เป็น Hook/requestIdleCallback ทำหน้าที่ช่วยเรื่อง ให้ Browser จัดลำดับการทำเอง Scroll แม่นยำและลดการใช้ CPU
export const restoreScrollPosition = (tag:string) => {
    const savedScroll = sessionStorage.getItem(tag);
    if (savedScroll) {
      requestIdleCallback(() => {
        window.scrollTo({
          top:parseInt(savedScroll),
          behavior:"smooth"
          });
      });
    }
  };
